import { ExternalLink } from 'lucide-react';

export const sponsors = [
  {
    id: 'abracadabra',
    name: 'Abracadabra NYC',
    tagline: 'Costumes, magic & props — the city\'s legendary shop.',
    cta: 'Shop Abracadabra',
    href: 'https://www.awin1.com/cread.php?awinmid=83201&awinaffid=2904123&campaign=Terrifier+Blind+Box&clickref=abra%40mgn&ued=https%3A%2F%2Fabracadabranyc.com',
    image: 'https://customer-assets.emergentagent.com/job_author-hub-59/artifacts/tewgq9r7_Copilot_20260528_213518.png',
  },
  {
    id: 'alex-vincent',
    name: 'Alex Vincent 2026 · Abracadabra NYC',
    tagline: 'The Child\'s Play star comes to Abracadabra. Signed memorabilia and event details.',
    cta: 'See the event',
    href: 'https://www.awin1.com/cread.php?awinmid=83201&awinaffid=2904123&campaign=Alex+Vincent+2026&ued=https%3A%2F%2Fabracadabranyc.com',
    image: '/ads/alex-vincent.jpg',
  },
  {
    id: 'brkox',
    name: 'BRKOX',
    tagline: 'Display cases, frames and light kits built for your brick sets.',
    cta: 'Shop BRKOX',
    href: 'https://www.awin1.com/cread.php?awinmid=129093&awinaffid=2904123&campaign=BRKOX+US+Affiliate+Push&ued=https%3A%2F%2Fbrkox.com',
    image: '/ads/brkox.jpg',
  },
  {
    id: 'kingscamo',
    name: 'King\'s Camo',
    tagline: 'Mountain-tested camouflage and hunting apparel.',
    cta: 'Shop King\'s Camo',
    href: 'https://www.awin1.com/cread.php?awinmid=116187&awinaffid=2904123&ued=https%3A%2F%2Fkingscamo.com',
    image: '/ads/kingscamo.jpg',
  },
  {
    id: 'moonbike',
    name: 'MoonBike',
    tagline: 'Electric bikes built for the mountain and the morning commute.',
    cta: 'Explore MoonBike',
    href: 'https://tidd.ly/4dN1euR',
    image: 'https://customer-assets.emergentagent.com/job_author-hub-59/artifacts/24nntcyj_about.webp',
  },
];

export default function SponsorBand({ ids, label = 'Partners we recommend' }) {
  const list = ids ? sponsors.filter((s) => ids.includes(s.id)) : sponsors;
  return (
    <section className="py-10 md:py-14 border-y border-border/30 bg-card/30" data-testid="sponsor-band">
      <div className="container-custom">
        <div className="flex items-center gap-3 mb-6">
          <span className="text-[10px] uppercase tracking-[0.3em] font-bold text-muted-foreground">{label}</span>
          <span className="flex-1 h-px bg-border/60" />
          <span className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground/70">Affiliate</span>
        </div>
        <div className={`grid gap-4 ${list.length === 2 ? 'md:grid-cols-2' : ''} ${list.length >= 3 ? 'md:grid-cols-2 xl:grid-cols-3' : ''}`}>
          {list.map((s) => (
            <a
              key={s.id}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer sponsored"
              className="group flex items-center gap-5 rounded-2xl bg-card border border-border/50 p-4 md:p-5 hover:border-accent/50 transition-[border-color,transform] duration-300 hover:-translate-y-0.5"
              data-testid={`sponsor-${s.id}`}
            >
              <div className="w-24 h-24 md:w-32 md:h-32 shrink-0 rounded-xl overflow-hidden bg-black/40">
                <img src={s.image} alt={s.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-[10px] uppercase tracking-[0.2em] text-accent font-bold mb-1">Sponsored</p>
                <h3 className="font-bold text-lg leading-tight">{s.name}</h3>
                <p className="text-sm text-muted-foreground mt-1 leading-relaxed">{s.tagline}</p>
                <span className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-foreground group-hover:text-accent transition-colors">
                  {s.cta} <ExternalLink className="w-3.5 h-3.5" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
